var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUpGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.307096 14.1929C0.503985 14.3895 0.770876 14.5 1.04915 14.5C1.32741 14.5 1.59431 14.3895 1.79119 14.1929L11.8999 4.08424V12.0508C11.8999 12.3293 12.0105 12.5963 12.2074 12.7933C12.4043 12.9902 12.6714 13.1008 12.9499 13.1008C13.2284 13.1008 13.4955 12.9902 13.6924 12.7933C13.8894 12.5963 14 12.3293 14 12.0508V1.55007C14 1.27157 13.8894 1.00448 13.6924 0.807558C13.4955 0.610632 13.2284 0.5 12.9499 0.5H2.44924C2.17074 0.5 1.90365 0.610632 1.70673 0.807558C1.5098 1.00448 1.39917 1.27157 1.39917 1.55007C1.39917 1.82856 1.5098 2.09565 1.70673 2.29258C1.90365 2.48951 2.17074 2.60014 2.44924 2.60014H10.4158L0.307096 12.7088C0.110452 12.9057 0 13.1726 0 13.4509C0 13.7291 0.110452 13.996 0.307096 14.1929Z",
    fill: "#33A06F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpGreen);
export default __webpack_public_path__ + "static/media/ArrowUpGreen.d624896c0416f5d6b0175dfab7e5a2cf.svg";
export { ForwardRef as ReactComponent };